








































import { ClientAccountEmailHistory } from '@/shared/clients/client-account-email-history';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ViewEmailDialog extends Vue {
    @Prop({ required: true }) private email!: ClientAccountEmailHistory;
    @Prop({ required: true }) private visible!: boolean;

    private isVisible: boolean = this.visible;

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
